module.exports = __webpack_public_path__ + "img/afgl.f803731e.svg";